import React from "react";

import ExperienceHero from "./ExperienceHero/experienceHero";
import Timeline from "./Timeline/timeline";

const Experience = () => {
  return (
    <div>
      <ExperienceHero />
      <Timeline />
    </div>
  );
};

export default Experience;
